import { ClientService } from '@fitness-force/api';
import { Store } from '@ngrx/store';
import { CommonModule } from '@angular/common';
import { Component, OnInit, ChangeDetectionStrategy, Input, Output, EventEmitter } from '@angular/core';
import { FormsModule, ReactiveFormsModule, UntypedFormGroup, UntypedFormBuilder, Validators, UntypedFormControl } from '@angular/forms';
import { BadRequestError, NotFoundError } from '@fitness-force/errors';
import {AssignedToComponent} from '@fitness-force/common/assigned-to'
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { AvatarModule } from 'primeng/avatar';
import { BlockUIModule } from 'primeng/blockui';
import { ButtonModule } from 'primeng/button';
import { DialogModule } from 'primeng/dialog';
import { SelectModule } from 'primeng/select';
import { InputTextModule } from 'primeng/inputtext';
import { PasswordModule } from 'primeng/password';
import { RippleModule } from 'primeng/ripple';
import { StyleClassModule } from 'primeng/styleclass';

import { BehaviorSubject } from 'rxjs';
import {  ShortNamePipe} from '@fitness-force/pipes/short-name'
import { ToastMessageService } from '@fitness-force/api';
import { MessageModule } from 'primeng/message';
import { ChipModule } from 'primeng/chip'
import { StaffStoreService } from 'libs/api/src/lib/staff/staff-store.service';

@Component({
  selector: 'change-sales-representative',
  templateUrl: './change-sales-representative.component.html',
  styleUrls: ['./change-sales-representative.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [CommonModule,
    SelectModule,
    FormsModule,
    ReactiveFormsModule,
    DialogModule,
    AvatarModule,
    ButtonModule,
    RippleModule,
    BlockUIModule,
    StyleClassModule,
    InputTextModule,
    PasswordModule,
    ShortNamePipe,
    AvatarModule,
    AssignedToComponent,
    MessageModule,
    ChipModule,
    TranslateModule],
})
export class ChangeSalesRepresentativeComponent implements OnInit {
  @Input() changeRepresentativeModal: boolean | null = false;
  @Input() clientData$ = new BehaviorSubject<any>(null)
  @Output() closeChangeRepresentativeDialog = new EventEmitter()
  attachments: any;
  allClientData$ = new BehaviorSubject<any>({})
  clientData: any
  currentStaff$ = new BehaviorSubject<any>({})
  selectedStaff$ = new BehaviorSubject<any>({})
  allStaffs$ = new BehaviorSubject<any>([])
  updateClientRepFormGroup: UntypedFormGroup = new UntypedFormGroup({})
  isClientRepresentative = new BehaviorSubject(true);
  claims: string[] = ['can_be_client_rep'];
  isloading:boolean=false;

  constructor(private store: Store, public translate: TranslateService, private clientService: ClientService,
     private fb: UntypedFormBuilder, private toastMessageService: ToastMessageService, private staffStoreService: StaffStoreService) { }

  ngOnInit(): void {
    this.componentInit()
  }
  componentInit() {
    this.updateClientRepFormGroup = this.fb.group({
      newRepresentative: [null, [Validators.required]]
    })
    this.clientData$.subscribe(
      (client: any) => {
        this.allClientData$.next(client)
        this.clientData = client;
        this.staffStoreService.getStaffById(client.client_representative_id).subscribe((staff: any) => {
          this.currentStaff$.next(staff)
          this.selectedStaff$.next(staff)
          //this.NewRepresentative.setValue(staff.id)
        })
        // this.store.select(STAFF_STATE).subscribe((staff: any) => {
        //   this.allStaffs$.next(staff.staffListAll)
        //   let defaultStaff :any;
        //   if(staff.staffListAll.find((s: any) => client.client_representative_id == s.id))
        //   {
        //     defaultStaff = staff.staffListAll.find((s: any) => client.client_representative_id == s.id);
        //   }
        //   else if(staff.staffList.find((s: any) => client.client_representative_id == s.id))
        //   {
        //     defaultStaff = staff.staffListAll.find((s: any) => client.client_representative_id == s.id);
        //   }
        //   this.currentStaff$.next(defaultStaff)
        //   this.selectedStaff$.next(defaultStaff)
        //   //this.NewRepresentative.setValue(defaultStaff.id)
        // })
      })
  }

  get NewRepresentative(): UntypedFormControl {
    return this.updateClientRepFormGroup.get('newRepresentative') as UntypedFormControl;
  }

  selectStaff(staff: any) {
    this.selectedStaff$.next(staff)
    this.NewRepresentative.setValue(staff.id)
  }

  updateClientRepresentative() {
  this.isloading=true;
    const client_rep_model = {
      "home_club_tenant_id": this.clientData.home_club_tenant_id,
      "full_name": this.clientData.full_name,
      "mobile_country_code": this.clientData.mobile_country_code,
      "mobile_number": this.clientData.mobile_number,
      "email_id": this.clientData.email_id,
      "date_of_birth": this.clientData.date_of_birth,
      "gender": this.clientData.gender,
      "location": this.clientData.location,
      "second_mobile_country_code": this.clientData.second_mobile_country_code,
      "second_mobile_number": this.clientData.second_mobile_number,
      "preferred_language": this.clientData.preferred_language,
      "place_id": this.clientData.place_id,
      "address": this.clientData.address,
      "city_code": this.clientData.city_code,
      "state_code": this.clientData.state_code,
      "country_code": this.clientData.country_code,
      "address_pin_code": this.clientData.address_pin_code,
      "emergency_contact_number": this.clientData.emergency_contact_number,
      "emergency_contact_person": this.clientData.emergency_contact_person,
      "source": this.clientData.source,
      "channel": this.clientData.channel,
      "heartrate_monitoring_id": this.clientData.heartrate_monitoring_id,
      "referred_by": this.clientData.referred_by,
      "promotional_sms": this.clientData.promotional_sms,
      "promotional_email": this.clientData.promotional_email,
      "medical_alert": this.clientData.medical_alert,
      "note": this.clientData.note,
      "taxnumber": this.clientData.taxnumber,
      "custom_fields": this.clientData.custom_fields,
      "current_keyfob": this.clientData.current_keyfob,
      "client_representative_id": this.NewRepresentative.value.id
    }


    this.allClientData$.subscribe((client: any) => {
      this.clientService.changeClientRepresentative(client.id, client.home_club_tenant_id == 0 ? client.createdin_tenant_id : client.home_club_tenant_id, client_rep_model).subscribe({
        next: async (res: any) => {
          this.translate.get('SALE_REPRESENTATIVE.MSG_CHANGED',{ clientname: client.full_name})
          .subscribe((translation) => {
            this.toastMessageService.showSuccess(translation);
          });
          this.isloading=false;
          await this.timeout(1000);
          this.closeDialogEvent(true);
        },
        error: (error) => {
          this.toastMessageService.showError(error);
        }
      })
    })

  }

  closeDialogEvent(updated = false) {
    this.closeChangeRepresentativeDialog.emit(updated ? { action: "updated" } : updated)
  }

  timeout(ms: any) {
    return new Promise((resolve) => setTimeout(resolve, ms));
  }
}
